export default __webpack_public_path__ + "static/logo-act-8039c8d448b68ea58687e04c8b639955.png";